import React, { useEffect, useState } from 'react'
import {
  Input,
  Modal,
  message,
  Form,
} from "antd";
import Select from "react-select";
import { signupUser } from '../../../api/api';
import axiosInstance from '../../../utils/axiosInstance';
import { useSelector } from 'react-redux';



const AddUserModel = ({ userFormModal, handleCancel, onSuccessAdd }) => {
  const [form] = Form.useForm();
  const [allDepartments, setAllDepartments] = useState();
  const token = useSelector((state) => state.auth.accessToken);
  const [department, setDepartment] = useState();
  const [role, setRole] = useState();
  const [loading, setLoading] = useState(false);
  const [businessHead, setBusinessHead] = useState();
  const [business_head_id, setBusinessHeadId] = useState();
  const select = useSelector((state) => state.auth);
  const userRole = select.userInfo.role;

  console.log(userRole, "userRole")
  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const response = await axiosInstance.get(`/department/get/`, { customParams: { is_active: "False", page_size: 100 } })
        setAllDepartments(response.data); // Update the state with the fetched user data
      } catch (error) { }
    };
    fetchDepartment();
  }, []);

  const handleOk = () => {
    form.submit();
  };
  const handleRole = (value) => {
    setBusinessHeadId(undefined);
    form.setFieldsValue({ business_head_id: undefined });
    setRole(value);
  };

  const onFinishUser = async () => {
    await form.validateFields();
    const values = await form.getFieldsValue();
    if (values.business_head_id) {
      values.business_head_id = values.business_head_id.value;
    }
    values.department = values.department.value;
    if (values.role) {
      values.role = values.role.value;
    }
    // if (userRole === "superadmin") {
    //   values.role = "Support";
    // }

    try {
      setLoading(true);
      const { res } = await signupUser(
        {
          department: values.department,
          email: values.email,
          employee_id: values.employee_id,
          role: values.role,
          first_name: values.first_name,
          ...(values.business_head_id && {
            business_head_id: values.business_head_id,
          }),
        },
        token
      );
      if (res.status === 201) {
        message.success("User created successfully.");
        form.resetFields();
        onSuccessAdd();
        setRole(null);
      } else {
        message.error(res);
        // form.resetFields();
      }
    } catch (err) {
      message.error(err.error);
    } finally {
      setLoading(false);
    }
  };
  const fetchHeadName = async (props) => {
    try {
      const response = await axiosInstance.get(`/user/get/`, { customParams: props })
      setBusinessHead(response.data);
    } catch (error) { }
  };

  useEffect(() => {
    if (role === "Businessteam") {
      fetchHeadName({ role: "Businesshead" });
    } else if (role === "Agreement controller Team") {
      fetchHeadName({ role: "Agreement controller Head" });
    }
  }, [role]);

  const handleBusinessHeadId = (value) => {
    setBusinessHeadId(value);

  };
  console.log(role, "role")
  // useEffect(() => {
  //   if (userRole === "superadmin") {
  //     form.setFieldsValue({ role: "Support" });
  //   }
  // }, [userRole]);

  return (
    <Modal
      title="Add New User"
      open={userFormModal}
      onOk={() => handleOk()}
      onCancel={handleCancel}
      style={{ fontSize: "24px", padding: "40px" }}
      okText="Save"
      okButtonProps={{
        style: {
          backgroundColor: "#4E36A3",
          color: "white",
          height: "40px",
          width: "100px",
        },
        disabled: loading, // Disable the button when loading is true
      }} // Set background color for the Ok button
      cancelButtonProps={{
        style: {
          backgroundColor: "",
          color: "#4E36A3",
          height: "40px",
          width: "100px",
        },
      }} // Set background color for the Cancel button
    >
      {/* <p>{modalText}</p> */}
      <Form form={form} onFinish={onFinishUser}>
        <Form.Item
          label="User Name"
          name="first_name"
          style={{ marginBottom: 20 }}
          rules={[{ required: true, message: "Please enter your username" }]}
        >
          <Input placeholder="Enter your username" />
        </Form.Item>
        <Form.Item
          name="email"
          label="Email Address"
          style={{ marginBottom: 20 }}
          rules={[
            { required: true, message: "Please enter your email address" },
            { type: "email", message: "Please enter a valid email address" },
          ]}
        >
          <Input type="email" placeholder="Enter your email address" />
        </Form.Item>
        <Form.Item
          name="employee_id"
          label="Employee ID"
          style={{ marginBottom: 20 }}
        >
          <Input
            placeholder="Please enter employee Id"
          />
        </Form.Item>
        <Form.Item
          name="department"
          label="Department"
          style={{ marginBottom: 20 }}
          rules={[{ required: true, message: "Please select a department" }]}
        >
          <Select
            options={
              allDepartments
                ? Object.values(allDepartments).map((department) => ({
                  value: department.id,
                  label: department.name,
                }))
                : []
            }
            onChange={(value) => setDepartment(value)}
          />
        </Form.Item>

        {
          userRole === "superadmin" ?
            <>
              <Form.Item
                name="role"
                label="Role"
                style={{ marginBottom: 20 }}
                rules={[{ required: true, message: "Please select a Role" }]}
              >
                <Select
                  options={[
                    { value: "Support", label: "Support" },
                    { value: "Demo", label: "Demo" },
                  ]}
                  onChange={(selectedOption) => handleRole(selectedOption)}
                />
              </Form.Item>
            </>
            :

            <Form.Item
              name="role"
              label="Role"
              style={{ marginBottom: 20 }}
              rules={[
                {
                  required: true,
                  message: "Please select a Role",
                },
              ]}
            >
              <Select
                options={[
                  {
                    value: "Businessteam",
                    label: "Business Team",
                  },
                  {
                    value: "Businesshead",
                    label: "Business Head",
                  },
                  { value: "Agreement controller Team", label: "Agreement Control Team" },
                  { value: "Agreement controller Head", label: "Agreement Control Head" },
                ]}
                onChange={(selectedOption) =>
                  handleRole(selectedOption.value)
                }
                required
              />
            </Form.Item>
        }

        {role && role === "Businessteam" && (
          <>
            <Form.Item
              name="business_head_id"
              label="Business Head Name"
              style={{ marginBottom: 20 }}
              rules={[
                {
                  required: true,
                  message:
                    "Please select or add Business Head",
                },
              ]}
            >
              <Select
                options={
                  businessHead
                    ? Object.values(businessHead).map(
                      (businesshead) => ({
                        value: businesshead.id,
                        label: businesshead.first_name,
                      })
                    )
                    : []
                }
                onChange={(selectedOption) =>
                  handleBusinessHeadId(selectedOption.value)
                }
                required
              />
            </Form.Item>
          </>
        )}
        {role && role === "Agreement controller Team" && (
          <>
            <Form.Item
              name="business_head_id"
              label="Agreement controller Team"
              style={{ marginBottom: 20 }}
              rules={[
                {
                  required: true,
                  message: "Please select or add Legal Head",
                },
              ]}
            >
              <Select
                options={
                  businessHead
                    ? Object.values(businessHead).map(
                      (businesshead) => ({
                        value: businesshead.id,
                        label: businesshead.first_name,
                      })
                    )
                    : []
                }
                onChange={(selectedOption) =>
                  handleBusinessHeadId(selectedOption.value)
                }
                required
              />
            </Form.Item>
          </>
        )}
      </Form>
    </Modal>
  )
}

export default AddUserModel